import script from "./PatientPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientPage.vue?vue&type=script&setup=true&lang=ts"

import "./PatientPage.vue?vue&type=style&index=0&id=4f0ad6e3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f0ad6e3"]])

export default __exports__